import http from "./http";

export const createAccident = async (data: Record<string, unknown>) => {
  try {
    return await http.post(`/kinder/accidente/`, data);
  } catch (error) {
    console.error("[create] Error :: ", error);
    return null;
  }
};